import React from 'react'
import { Form, Input, Button, message } from 'antd';
import {  LockOutlined } from '@ant-design/icons';
import {  useHistory } from 'react-router-dom';

import logo from '../images/logo-SZ.png';
import Axios from 'axios';
const SERVICE_URL = window._env_.REACT_APP_SERVICE_URL;

export default function ForgotPassword(props) {
    const history = useHistory();
    const error = (response) => {
        message.error(response);
    };
  
    const success = (response) => {
      message.success(response);
    };
  


    const onFinish = (values) => {
          
          const tmppath = history.location.pathname.split('/');

          if(tmppath[3])
          {
            values.token = tmppath[3];
            // extara data to track 
            const headers = {
              "screen-name": "ERP_RESET_PASSWORD_PAGE",
              "action-name":"PAGE_SUBMIT",
              "app-code" : "ERP",
              "screen-url": window.location.href
            }
            const res = Axios.post(
              `${SERVICE_URL}reset-password`,values,{
                headers: headers
              })
              .then((response) =>  {
                
                if(response.data.status == 'failed') {
                  
                  if(typeof response.data.errors !== 'undefined') {
                    let i = 1;
                    Object.keys(response.data.errors).forEach(key => {
                      if(i==1){
                       message.error(response.data.errors[key][0]);
                      }
                      i++;
                    })
                  }
                } else {
                  success(response.data.message); 
                  history.push('/');
                }
              })
              .catch(er => {
              });
          } else {
            console.log(values);
          }
          
         
    };

    return (
        <div className="login-main">
        <div className="loginbg">
            <div className="loginmn">
              <div className="loginlogo">
                <img src={logo} alt="" />
                <p className="v-text">Admin Panel 2.0</p>
              </div>
              <Form
                name="reset_password"
                className="login-form"
                initialValues={{
                    remember: true,
                }}
                onFinish={onFinish}
                >
                <div className="form-label">
                  <h4>Reset Password</h4>
                </div>
               
                <Form.Item
                        name="password"
                        rules={[
                          {
                              required: false,
                              message: 'Please input your New password!',
                          },
                        ]}
                    >
                        <Input.Password 
                         prefix={<LockOutlined className="site-form-item-icon" />}
                        type="password"
                        placeholder="Password"
                        />
                </Form.Item>
                <Form.Item
                        
                        dependencies={['password']}
                        name="confirm_password"
                        rules={[
                        {
                            required: false,
                            message: 'Please confirm the Password!',
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (!value || getFieldValue('password') === value) {
                              return Promise.resolve();
                            }
              
                            return Promise.reject(new Error('Confirm password does not match!'));
                          },
                        }),
                        ]}
                    >
                        <Input.Password 
                         prefix={<LockOutlined className="site-form-item-icon" />}
                        type="password"
                        placeholder="Confirm Password"
                        />
                </Form.Item>
               <p className="left-text">Your password should contains at least 8 characters with 1 Uppercase 1 Lowercase 1 Numeric and 1 special character</p>   
              <Form.Item className="form-bottom-info">
                  <Button style={{float:"left"}} type="primary" htmlType="submit" className="login-form-button">
                   Reset
                  </Button>
                  
              </Form.Item>
              
              </Form>
               
            </div>
        </div>
    </div>
    )
}
